<template >
    <el-dialog
            :title="'合同详情'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <div id="left" style="text-align: left">


            <el-form :model="dataForm" ref="dataForm"
                     label-width="120px">

                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="'姓名'">
                            <div class="min-input-class">{{dataForm.xm}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="'工号'">
                            <div class="min-input-class">{{dataForm.workNumber}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="'部门'">
                            <div class="min-input-class">{{dataForm.bmmc}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="'签订日期'">
                            <div class="min-input-class">{{dataForm.ldhtqdrq?dataForm.ldhtqdrq.substr(0,10):''}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="'起始日期'">
                            <div class="min-input-class">{{dataForm.ldhtqsrq?dataForm.ldhtqsrq.substr(0,10):''}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="'合同期限(年)'">
                            <div class="min-input-class">{{getqx(dataForm)}}</div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="'截止时间'" >
                            <div class="min-input-class">{{getJzrq(dataForm)}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="'工资'"  >
                            <div class="min-input-class">{{dataForm.ldhtgz}}</div>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="'同步工资生效日期'" >
                            <div class="min-input-class">{{ dataForm.tbgzsxrq?dataForm.tbgzsxrq.substr(0,10):''}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="'需补贴(月)'"  >
                            <div class="min-input-class">{{dataForm.xbty}}</div>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
    </el-dialog>
</template>

<script>


    export default {
        data () {
            return {
                visible: false,
                dataForm:{
                    id: '',
                    ldhtqdrq: '',
                    ldhtqsrq: '',
                    ldhtjzrq: '',
                    ldhtqx: '',
                    ldhtgz: '',
                    tbgzsxrq: '',
                    attach:'',
                    userid:'',
                    xbty:'',
                    xm:'',
                    workNumber:'',
                    bmmc:''

                }
            }
        },
        created () {

        },
        methods: {
            init (id) {
                if(!id) return
                this.visible = true
                this.dataForm = {}
               this.$nextTick(() => {
                   this.dataForm = id
                   // this.$http({
                   //     url: `/bjba/workContract/info/${id}`,
                   //     method: 'get'
                   // }).then(({data}) => {
                   //     console.log(data)
                   //     this.dataForm.id    = data.data.id
                   //     this.dataForm.ldhtqdrq= data.data.ldhtqdrq
                   //     this.dataForm.ldhtqsrq     = data.data.ldhtqsrq
                   //     this.dataForm.ldhtjzrq = data.data.ldhtjzrq
                   //     this.dataForm.ldhtqx  = data.data.ldhtqx
                   //     this.dataForm.ldhtgz  =  data.data.ldhtgz
                   //     this.dataForm.tbgzsxrq = data.data.tbgzsxrq
                   //     this.dataForm.attach = data.data.attach
                   //     this.dataForm.userid = data.data.userid
                   //     this.dataForm.xbty= data.data.xbty
                   //     this.dataForm.xm = data.data.xm
                   //     this.dataForm.workNumber = data.data.workNumber
                   //     this.dataForm.bmmc = data.data.bmmc
                   // })
               })
            },
            getJzrq(row) {
                if(row.isFixed == 1) return '不固定'
                else if(row.isFixed ==0) {
                    return  row.ldhtjzrq?row.ldhtjzrq.substr(0,10):''
                }
            },
            getqx(row) {
                if(row.isFixed == 1) return '不固定'
                else if(row.isFixed ==0) {
                    return  row.ldhtqx
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .min-input-class {

        min-height:25px;
        border-bottom:1px dotted  #b0b1b3;
    }
</style>
